import { useMemo } from "react";

import { useAllCurrencies } from "~/modules/country/api/currency/currencyQueries.ts";
import type { Currency } from "~/modules/country/api/currency/currencyTypes.ts";
import type { FormInputOption } from "~/types/form.ts";
import { mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import type { SortDirection } from "~/utils/sortFunctions.ts";
import { byMultipleObjectProperties } from "~/utils/sortFunctions.ts";


const useCurrencySelectOptions = (): FormInputOption[] => {
	const { data: allCurrenciesData } = useAllCurrencies();
	return useMemo(() => {
		if (allCurrenciesData) {
			const sortOptions:{ property: keyof Currency; direction: SortDirection }[] = [
				{ property: "listPriority", direction: "desc" },
				{ property: "displayName", direction: "asc" },
			];
			const sortedCurrencies = allCurrenciesData.filter(currency => currency.listPriority !== null).sort(byMultipleObjectProperties(sortOptions));
			return mapDataToInputOptionsData(sortedCurrencies, "id", "displayName");
		}
		return [];
	}, [allCurrenciesData]);
};

export default useCurrencySelectOptions;

